@if (anchor) {
  <a [id]="anchor"></a>
}
<div class="surface">
  <div #numberElement class="number">
    @if (attributes.prefix) {
      {{ attributes.prefix }}
    }
    @if (currentNumber() > 0) {
      @if (attributes.showNumberSign) {
        +
      }
    } @else if(currentNumber() < 0) {
      -
    }
    {{ currentNumberAbsolute() | appAdvancedNumber:(attributes.notation ?? 'compact'):numberStyle:attributes.currencyCode:attributes.minimumFractionDigits:attributes.maximumFractionDigits:attributes.grouping }}
    @if (attributes.unit) {
      {{ attributes.unit }}
    }
  </div>
  <kb-html class="text" [html]="attributes.textHtml" [appEditorId]="editorIds?.textHtml"></kb-html>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
